import React from 'react'

export const ComponentLoader = () => {
    return (
        <div style={{display:'flex', justifyContent: 'center', alignItems:'center', height: '100vh' }}>
            <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    )
}
